import { WaitingList } from "@/features/shelter/WaitingList";

export function WaitingListPage() {
  return <WaitingList />;
}
